import $api from '@/utils/api';
import Logger from '@/utils/logger';

export default {
  async getModules(topicId) {
    const response = await $api.get(`/topics/${topicId}/modules`);

    if (!response.success) {
      Logger.error(response.message);
      return { records: [] };
    }

    return response;
  },

  async getModule(moduleId) {
    const response = await $api.get(`/modules/${moduleId}`);

    if (!response.success) {
      Logger.error(response.message);
      return { record: null };
    }

    return response;
  },

  async getRunningModule(hostId) {
    const response = await $api.get(`/facilitators/${hostId}/running-modules`);

    if (!response.success) {
      // Logger.debug('No running modules.');
      return { record: null };
    }

    return response;
  },
};
